import { useWindowDimensions } from 'react-native';

import { SMALL_LOGO_CONTAINER_SIZE } from '@/components/ButtonTitleIcon';
import { SCROLLBAR_WIDTH } from '@/feature/responsive-design/WebComponents';
import { MAX_WEB_WIDTH } from '@/utils/constants-platform-specific';

export const SEARCH_BAR_HEIGHT = SMALL_LOGO_CONTAINER_SIZE;
export const SEARCH_BAR_PADDING = 16;
export const SEARCH_ICON_WIDTH = 24;
export const SEARCH_TEXT_WIDTH = 54; // it's the width of the text "Search"
export const CANCEL_BUTTON_WIDTH = 78;
export const SEARCH_BAR_PADDING_TOP = 8;

/**
 * The purpose of this hook is to offer one source of truth for all search bar sizes
 * The SearchBar can have many dimensions, when it's on the lobby it's full width,
 * when in transforms into a tile it looks like a square,
 * when it's on the search screen it full width without the cancel button space
 */
export const useSearchDimensions = () => {
    const { width } = useWindowDimensions();
    const maxAvailableWidth = MAX_WEB_WIDTH > width ? width - SCROLLBAR_WIDTH : MAX_WEB_WIDTH;
    const fullSearchBarWidth = maxAvailableWidth - SEARCH_BAR_PADDING * 2;
    const searchMaxWidthOnSearchScreen = maxAvailableWidth - SEARCH_BAR_PADDING - CANCEL_BUTTON_WIDTH;

    return { maxAvailableWidth, fullSearchBarWidth, searchMaxWidthOnSearchScreen };
};
